import React from "react";
import moment from "moment";

import "./styles.css";
import { Images } from "../../config";

const ApplicationRowSubmitted = (props) => {
  const appData = props?.item;

  return (
    <div key={props.index} className="application-row-submitted">
      <div className="flex gap-3 w-full">
        <div className="approw-image-container">
          <img
            src={appData?.university?.profilePic ?? Images.LogoIconOnly}
            className="approw-image"
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = Images.LogoIconOnly;
            }}
          />
        </div>
        <div className="flex flex-col justify-center gap-2 w-[83%]">
          <div className="app-row-heading">
            {appData?.university?.name} Application
          </div>
          <div className="app-row-subheading">{appData?.university?.name}</div>
        </div>
      </div>
      <div className="flex flex-col justify-center gap-2 pl-4">
        <div className="app-row-heading">
          {appData?.university?.deadlines?.length > 0
            ? appData?.university?.deadlines[0].deadlineType ??
              "Application Deadline"
            : "Application Deadline"}
        </div>
        <div className="app-row-subheading">
          {appData?.university?.deadlines?.length > 0
            ? appData?.university?.deadlines[0].appDeadline
              ? moment(appData?.university?.deadlines[0].appDeadline).format(
                  "DD MMMM, YYYY"
                )
              : "NA"
            : "NA"}
        </div>
      </div>

      <div className="flex flex-col justify-center gap-2">
        <div className="app-row-heading">Date of Submission</div>
        <div className="app-row-subheading">
          {appData?.dateOfApplication
            ? moment(appData?.dateOfApplication).format("DD MMMM, YYYY")
            : "NA"}
        </div>
      </div>
    </div>
  );
};

export default ApplicationRowSubmitted;
